module.exports = __webpack_public_path__ + "static/media/tom.d42b3945.webp";